import React from 'react';
import breakpoints from '@99designs/asimov/platform-settings/settings/breakpoints';
import Responsive from 'react-responsive';

export default function Desktop({ children, values }) {
    return <Responsive minWidth={breakpoints.normal[0]} children={children} values={values} />;
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Desktop.jsx